import 'tooltipster';

if ($('.js-onekey-nav-item').length) {
  $('.js-onekey-nav-item').tooltipster({ side: 'left', delay: 200, animation: 'fade' });
}
